'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setAdEnded;

var _constants = require('../constants');

function setAdEnded(playerId, adEnded) {
  return {
    type: _constants.SET_AD_ENDED,
    adEnded: adEnded,
    playerId: playerId
  };
} // Action for indicating that an ad was playing but has ended.
module.exports = exports['default'];